import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';

import Loader from '../loader';

export default class Header extends Component {

  /* Render */

  render() {
    return (
      <div className="header">
        <div className="container">
          <div className="row">
            <div className="gr-12">
              <div className="header__inner">
                <div className="align align--fluid align--gutter-xs">
                  {this.renderBackbutton()}
                  {this.renderTitle()}
                  {this.renderLoader()}
                  {this.renderActions()}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  renderActions() {
    if (this.props.actions) {
      return (
        <div className="align__cell align__cell--grow">
          {this.props.actions}
        </div>
      );
    }

    return (<div className="align__cell align__cell--grow" />);
  }

  renderBackbutton() {
    if (this.props.backbutton) {
      return (
        <div className="align__cell align__cell--shrink">
          <button className="header__button button button-color-gray-dark" onClick={this.props.backbutton}>
            <span className="icon icon-arrow-left" />
          </button>
        </div>
      );
    }

    return null;
  }

  renderLoader() {
    return (
      <div className="align__cell align__cell--shrink">
        <Loader size="md" color="#FFD000" visible={this.props.loading} />
      </div>
    );
  }

  renderTitle() {
    if (this.props.title) {
      return (
        <div className="align__cell align__cell--shrink">
          <h1 className="header__title">
            <FormattedMessage id={this.props.title} />
          </h1>
        </div>
      );
    }

    return null;
  }
}

Header.defaultProps = {
  loading: false,
};

Header.propTypes = {
  actions: PropTypes.node,
  backbutton: PropTypes.func,
  loading: PropTypes.bool,
  title: PropTypes.string,
};



// WEBPACK FOOTER //
// ./js/components/header/index.jsx